module.exports = __webpack_public_path__ + "klara-logo.28cc0d803dba69ee64ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/klara-logo.png
// module id = 225
// module chunks = 12